<template>
<div class="lvTitleBox clear-fix">
  <h1 >{{ title }}</h1>

  <div class="floatBox clear-fix">
    <div class="floatBoxLeft">
      <h2 ><pre>{{ timeStr }}</pre></h2>
<!--      <h3 ><pre v-if="unitInfo!=''">主办单位:</pre></h3>-->
<!--      <h4 ><pre v-if="unitInfo!=''">{{ unitInfo }}</pre></h4>-->
    </div>

    <div class="floatBoxRight">
      <div class="lvStatue">{{ liveState }}</div>
    </div>
  </div>


</div>
</template>

<script>
import {actUtil} from "../../../js/activity/util";
import {utils} from "../../../network/utils";

export default {
  name: "lvTitle",
  props:{
    baseInfo: {
      type: Object,
      required: true
    },
    // title:{
    //   type: String,
    //   default: '标题'
    // },
    // timeStr:{
    //   type: String,
    //   default: '-'
    // },
    // unitInfo:{
    //   type: String,
    //   default: '-'
    // },
    liveState:{
      type: String,
      default: '-'
    }
  },
  computed:{
    title(){
      // console.log("this.baseInfo.title=="+this.baseInfo.title)
      if(typeof this.baseInfo.title != "undefined"){
        return this.baseInfo.title
      }else{
        return '标题'
      }
    },
    timeStr(){
      if(typeof this.baseInfo.startTime != "undefined"){
        // return utils.date('m-d l H:i', this.baseInfo.startTime)
        // return this.baseInfo.startTime
        let str = utils.date('Y-m-d H:i', this.baseInfo.startTime)
        str += '~'
        str += utils.date('H:i', this.baseInfo.endTime)
        // console.log(str)
        return str
      }else{
        return '-'
      }
    },
    unitInfo(){
      if(typeof this.baseInfo.organizers != "undefined"){
        // let arr = JSON.parse(this.baseInfo.organizers)
        return actUtil.jsonToString(this.baseInfo.organizers, 1, "\n")
      }else{
        return '-'
      }
    }
  }
}
</script>

<style scoped>
.lvTitleBox{
  color: #212830;
}
.floatBox{
  position: relative;
  width: 100%;
  min-height: 100px;
  /*background-color: #ff5777;*/
  margin-bottom: 40px;
}
.floatBoxLeft{
  float: left;
  width: 780px;
  /*background-color: #790e0e;*/
  overflow: hidden;
  text-overflow: ellipsis;

}
.floatBoxRight{
  float: right;
}
.lvTitleBox h1{
  color: #30353c;
  font-size: 50px;
  margin-bottom: 40px;
}
.lvTitleBox h2{
  font-size: 40px;
  margin-bottom: 40px;
}
.lvTitleBox h3,h4{
  float: left;
  width: 210px;
  min-height: 55px;
  /*background-color: #ead287;*/
  font-size: 40px;
  line-height: 55px;
  font-weight: bolder;
}
.lvTitleBox h4{
  width: 500px;
  overflow:auto;
  word-wrap: break-word;
  font-weight: normal;
}
.lvStatue{
  margin-top: 8px;
  width: 180px;
  height: 60px;
  background-color: #4b9fff;
  font-size: 40px;
  color: whitesmoke;
  text-align: center;
  border-radius: 5px;
}
</style>